
import { Box, Modal } from '@mui/material';
import { useModalStore } from '../../../stores';
const baseUrl = process.env.REACT_APP_API_URL;





export const ModalVerImagen = ({ img, carpeta }) => {

    
    const { modalImagen, toggleModalImg } = useModalStore();
    const fileUrl = img ? `${baseUrl}/uploads/${carpeta}/${img}` : `${baseUrl}/uploads/${carpeta}/xxxx`;

    const cerrarModal = () => {
        toggleModalImg(false);
    }


    return (

        <Modal aria-labelledby="transition-modal-title" aria-describedby="transition-modal-description"
            open={ modalImagen } onClose={ cerrarModal } closeAfterTransition
        >

            <Box className="modal-estilo" sx={{ width: {xs:'75%', sm:'85%', md:'65%', lg:'60%'}, maxHeight: { xs:'90vh' },
                overflow:'hidden', borderRadius: {xs:2, sm:3}, display:'flex', flexDirection:'column',
                bgcolor:'background.paper', alignItems:'center',  justifyContent: 'center',  p:2, 
            }}>
                {img?.toLowerCase().endsWith('.pdf') 
                ? <iframe src={`${baseUrl}/uploads/${carpeta}/${img}`}
                    style={{ width:'100%', height:'80vh', border:'none' }}
                    title="PDF Viewer"
                />
                :   <img src={fileUrl}
                        alt="Imagen"
                        loading="lazy"
                        style={{ width:'auto', height:'auto', maxWidth:'90%', maxHeight:'75vh', 
                            objectFit:'contain', display:'block', margin:'auto', 
                    }}/>
                }
            </Box>

        </Modal>
    )

}
